// extracted by mini-css-extract-plugin
export default {"groupGiftTagWrapper":"groupGiftTagWrapper__ZDZhM","groupGiftTag":"groupGiftTag__ODkxN"};